module.exports = __webpack_public_path__ + "img/no-product-found.287f25b9.png";